import en from '../../profileContent.en';

const about = {
    ...en.about,
    metaTitle: 'Profil',
    metaDescription:
      'Profil mené par le fondateur d’Oreste Twizeyimana : ingénieur backend avec expérience .NET en production, pensée systémique issue de la mécatronique et forte capacité de communication.',
    eyebrow: 'Profil du fondateur',
    title: 'L’ingénieur derrière Oracle Consults',
    lead:
      'Cette pratique est fondée sur le modèle founder-led parce que son meilleur atout n’est pas une identité d’agence large, mais une combinaison précise de delivery backend en production, de pensée systémique et de communication claire construite sur du travail réel.',
    intro: [
      'La lecture la plus stable de l’ensemble des preuves n’est pas “développeur générique”. C’est ingénieur backend de production, penseur systémique, formateur et constructeur de logiciels liés à de vrais problèmes opérationnels.',
      'C’est important parce que l’offre de conseil de ce site n’est pas du marketing inventé. C’est une version condensée de ce que l’expérience, les projets et le profil soutiennent de manière cohérente.'
    ],
    quickFactsTitle: 'En un coup d’œil',
    quickFacts: [
      'Basé à Bydgoszcz, en Pologne, et ouvert aux collaborations à distance, hybrides ou avec option de relocalisation.',
      'Socle commercial : C#, .NET, ASP.NET Core, EF Core, SQL Server, intégrations, tests et support de production.',
      'Axe d’expansion : Python, FastAPI, Flask, automatisation, diagnostic et outils proches du système.',
      'Différenciateurs : mécatronique, communication multilingue, tutorat et pensée systémique.'
    ],
    sections: [
      {
        title: 'Ce qui rend ce profil distinctif',
        paragraphs: [
          'Beaucoup de profils en début de carrière ont une ou deux bonnes preuves. Celui-ci combine une vraie expérience backend en production, un projet de fin d’études sérieux lié à un vrai problème métier, une réelle amplitude en Python et une communication au-dessus de la moyenne.',
          'Le résultat est un consultant capable d’entrer dans le détail technique sans perdre le problème métier ni la dimension humaine de la livraison.'
        ]
      },
      {
        title: 'Pourquoi le logiciel opérationnel revient sans cesse',
        paragraphs: [
          'Le fil personnel le plus fort vient d’une exposition directe aux problèmes d’inventaire et de workflow dans les petites entreprises. C’est pour cela que le travail revient sans cesse vers les stocks, les réservations, le reporting, l’automatisation et les systèmes qui réduisent la friction manuelle.',
          'Il s’agit davantage d’empathie pratique que de fascination abstraite : le logiciel doit rendre les opérations complexes plus fiables pour ceux qui les gèrent.'
        ]
      },
      {
        title: 'Fondation commerciale',
        paragraphs: [
          'Le centre de gravité commercial reste Oponeo.pl, où le travail pointe de façon répétée vers des APIs ASP.NET Core, EF Core, SQL Server, des intégrations paiement et logistique, du tuning de performance, du refactoring legacy, une delivery Agile, des tests et du support de production.',
          'Cette expérience compte parce qu’elle prouve la capacité à travailler dans des systèmes avec du vrai trafic, de vraies dépendances et de vraies conséquences opérationnelles.'
        ]
      },
      {
        title: 'Mécatronique et pensée systémique',
        paragraphs: [
          'L’informatique et la mécatronique renforcent une manière de penser fondée sur l’intégration, la mesure, la fiabilité, le contrôle, les contraintes et les modes de panne.',
          'En conseil backend, cela se traduit par un meilleur jugement architectural, plus de rigueur sur les frontières et une meilleure intuition pour comprendre le comportement réel des systèmes.'
        ]
      },
      {
        title: 'Communication et transmission',
        paragraphs: [
          'Le tutorat en programmation et l’enseignement des langues ne sont pas des notes de bas de page. Ils renforcent la décomposition, la clarté, la patience et la capacité à adapter une explication au public concerné.',
          'Cela rend la collaboration plus fluide avec les clients, les fondateurs, les profils produit et les ingénieurs qui ont besoin d’une compréhension partagée de ce que fait le système et pourquoi.'
        ]
      }
    ],
    valuesTitle: 'Façon de travailler',
    values: [
      'Analytique : je cherche les causes, dépendances, contraintes et modes de panne, pas seulement les fonctionnalités livrées.',
      'Pragmatique : je privilégie le travail lié aux opérations, au reporting, aux workflows, aux intégrations et à une utilité métier visible.',
      'Orienté qualité : SOLID, clean architecture, tests, CI/CD et documentation font partie de la livraison.',
      'Adaptable : je peux passer de .NET à Python, du tutorat à l’automatisation et au travail de plateforme sans perdre la même identité centrale.'
    ],
    directionTitle: 'Direction',
    direction: [
      'Travail backend et plateforme dans des environnements produit techniquement exigeants.',
      'Systèmes métiers et plateformes opérationnelles où la fiabilité compte vraiment.',
      'Outils Python, automatisation et backend orienté services.',
      'Ingénierie backend plus orientée sécurité et diagnostic comme axe de progression.'
    ],
    practiceNote:
      'Conseil backend mené par le fondateur pour les logiciels opérationnels. Basé à Bydgoszcz, Pologne. Disponible à distance en Europe et à l’international.',
    closing:
      'Le cœur du profil n’est pas simplement “j’aime coder”. Il ressemble plutôt à ceci : je veux faire fonctionner des systèmes complexes de manière fiable pour de vraies personnes.'
  };

export default about;
